import { render, staticRenderFns } from "./TransformationPercentageModal.vue?vue&type=template&id=3bae06ab&scoped=true"
import script from "./TransformationPercentageModal.vue?vue&type=script&lang=js"
export * from "./TransformationPercentageModal.vue?vue&type=script&lang=js"
import style0 from "./TransformationPercentageModal.vue?vue&type=style&index=0&id=3bae06ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae06ab",
  null
  
)

export default component.exports